import { defineAsyncComponent } from 'vue'

import {
  PaymentIntegrationType,
  PaymentMethodCode,
  PaymentServiceProvider,
} from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

import type { PaymentFormAdapter } from '../types/PaymentFormAdapter'

const AdyenCardAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenCardAdapter/AdyenCardAdapter.vue'),
)

const AdyenFakeAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenFakeAdapter/AdyenFakeAdapter.vue'),
)

const AdyenGooglePayAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenGooglePayAdapter/AdyenGooglePayAdapter.vue'),
)

const AdyenHostedAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenHostedAdapter/AdyenHostedAdapter.vue'),
)

const AdyenKonbiniAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenKonbiniAdapter/AdyenKonbiniAdapter.vue'),
)

const AdyenMbwayAdapter = defineAsyncComponent(
  () => import('../adapters/AdyenMbwayAdapter/AdyenMbwayAdapter.vue'),
)

export const ApplePayAdapter = defineAsyncComponent(
  () => import('../adapters/ApplePayAdapter/ApplePayAdapter.vue'),
)

const ProcessOutCardAdapter = defineAsyncComponent(
  () => import('../adapters/ProcessOutCardAdapter/ProcessOutCardAdapter.vue'),
)

const PassThroughAdapter = defineAsyncComponent(
  () => import('../adapters/PassThroughAdapter/PassThroughAdapter.vue'),
)

const AchAdapter = defineAsyncComponent(
  () => import('../adapters/AchAdapter/AchAdapter.vue'),
)

const BacsAdapter = defineAsyncComponent(
  () => import('../adapters/BacsAdapter/BacsAdapter.vue'),
)

const SepaAdapter = defineAsyncComponent(
  () => import('../adapters/SepaAdapter/SepaAdapter.vue'),
)

// TODO, replace each adapter by the real one, once they are implemented
const CompatibilityAdapter = PassThroughAdapter
const ProcessOutHostedAdapter = PassThroughAdapter

type ConfigLevel1 = Record<PaymentServiceProvider, ConfigLevel2>
type ConfigLevel2 = Partial<Record<PaymentMethodCode, ConfigLevel3>> & {
  DEFAULT: ConfigLevel3
}
type ConfigLevel3 = Partial<
  Record<PaymentIntegrationType, PaymentFormAdapter>
> & {
  DEFAULT: PaymentFormAdapter
}

const ADYEN_COMMON = {
  [PaymentMethodCode.CARD]: {
    [PaymentIntegrationType.ADYEN_CHECKOUT_API]: AdyenCardAdapter,
    DEFAULT: CompatibilityAdapter,
  },
  [PaymentMethodCode.APPLE_PAY]: {
    DEFAULT: ApplePayAdapter,
  },
  [PaymentMethodCode.GOOGLE_PAY]: {
    DEFAULT: AdyenGooglePayAdapter,
  },
  [PaymentMethodCode.KONBINI_GENERIC]: {
    DEFAULT: AdyenKonbiniAdapter,
  },
  [PaymentMethodCode.MBWAY]: {
    DEFAULT: AdyenMbwayAdapter,
  },
  [PaymentMethodCode.FAKE]: {
    DEFAULT: AdyenFakeAdapter,
  },
  [PaymentMethodCode.ACH]: {
    DEFAULT: AchAdapter,
  },
  [PaymentMethodCode.BACS]: {
    DEFAULT: BacsAdapter,
  },
  [PaymentMethodCode.SEPA]: {
    DEFAULT: SepaAdapter,
  },
  DEFAULT: {
    [PaymentIntegrationType.ADYEN_CHECKOUT_API]: AdyenHostedAdapter,
    DEFAULT: PassThroughAdapter,
  },
}

export const PAYMENT_FORM_ADAPTER_NOT_REQUIRED = PassThroughAdapter

export const PAYMENT_FORM_ADAPTERS: ConfigLevel1 = {
  [PaymentServiceProvider.ADYEN_PAYIN_PAYOUT]: ADYEN_COMMON,
  [PaymentServiceProvider.ADYEN_MARKETPAY]: ADYEN_COMMON,

  [PaymentServiceProvider.PAYPAL]: {
    DEFAULT: {
      DEFAULT: PassThroughAdapter,
    },
  },

  [PaymentServiceProvider.PROCESSOUT]: {
    [PaymentMethodCode.CARD]: {
      DEFAULT: ProcessOutCardAdapter,
    },
    [PaymentMethodCode.APPLE_PAY]: {
      DEFAULT: ApplePayAdapter,
    },
    DEFAULT: {
      DEFAULT: ProcessOutHostedAdapter,
    },
  },
}
